export const THEME_MOOD = "THEME_MOOD"
